import { render } from "./menuConfigV3.vue?vue&type=template&id=5d575667&scoped=true&ts=true"
import script from "./menuConfigV3.vue?vue&type=script&lang=ts"
export * from "./menuConfigV3.vue?vue&type=script&lang=ts"

import "./menuConfigV3.vue?vue&type=style&index=0&id=5d575667&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d575667"]])

export default __exports__